module.exports = __webpack_public_path__ + "img/bs7.dfa83765.png";